import "./style.css";
import { jsx as c, jsxs as i } from "react/jsx-runtime";
import m from "../StarRating/StarRating.js";
const u = "_container_1rg2f_1", d = "_anchor_1rg2f_7", N = "_rating_1rg2f_12", g = "_reviewCount_1rg2f_25", r = {
  container: u,
  anchor: d,
  rating: N,
  reviewCount: g
}, h = 3, p = 5;
function A({
  rating: n,
  decimalPrecision: t = 2,
  ariaLabel: a,
  reviewCount: o,
  reviewCountTitle: s,
  minimumRating: e = h,
  maximumRating: _ = p,
  href: l
}) {
  const f = s && o ? s(o) : "";
  return !n || n < e || n > _ ? null : /* @__PURE__ */ c("div", { className: r.container, children: /* @__PURE__ */ i(M, { href: l, className: r.anchor, children: [
    /* @__PURE__ */ c(
      m,
      {
        rating: n,
        decimalPrecision: t,
        ariaLabel: a
      }
    ),
    !!n && /* @__PURE__ */ c("span", { className: r.rating, children: n.toFixed(1) }),
    !!o && /* @__PURE__ */ i("span", { className: r.reviewCount, title: f, children: [
      "(",
      o,
      ")"
    ] })
  ] }) });
}
function M({ href: n, children: t, className: a }) {
  return n ? /* @__PURE__ */ c("a", { href: n, className: a, children: t }) : t;
}
export {
  A as default
};
//# sourceMappingURL=ProductRating.js.map
